import { render, staticRenderFns } from "./CustomerWorklogReportView.vue?vue&type=template&id=1bfbffb6&"
import script from "./CustomerWorklogReportView.vue?vue&type=script&lang=js&"
export * from "./CustomerWorklogReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports